import React, { useState } from 'react';
import { BaseTableColumn, FieldData, TABLE_COLUMNS } from '../BaseTable';

const useTableSort = () => {
    const [sortField, setSortField] = useState<BaseTableColumn | null>(null);
    const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  
    const handleSort = (column: BaseTableColumn) => {
      if (sortField === column) {
        setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setSortField(column);
        setSortDirection("asc");
      }
    };
  
    const sortData = (data: Partial<FieldData>[]) => {
        return [...(data ?? [])].sort((a, b) => {
            if (!sortField) return 0;
        
            const fieldKey = TABLE_COLUMNS[sortField].field as keyof FieldData;
            const aVal = a?.[fieldKey];
            const bVal = b?.[fieldKey];
        
            if (aVal == null) return 1;
            if (bVal == null) return -1;
        
            //@ts-ignore
            if (TABLE_COLUMNS[sortField].dateString) {
                const aDate = new Date(aVal as string);
                const bDate = new Date(bVal as string);
                return sortDirection === "asc"
                  ? aDate.getTime() - bDate.getTime()
                  : bDate.getTime() - aDate.getTime();
            }

            if (typeof aVal === "string") {
              return sortDirection === "asc"
                ? (aVal as string).localeCompare(bVal as string)
                : (bVal as string).localeCompare(aVal);
            }
        
            if (typeof aVal === "number") {
              return sortDirection === "asc"
                ? (aVal as number) - (bVal as number)
                : (bVal as number) - (aVal as number);
            }
        
            return 0;
          });
    }

    return ({
        sortData,
        handleSort,
        sortField,
        sortDirection
    })
}

export default useTableSort;